// extracted by mini-css-extract-plugin
module.exports = {"productImages":"mS0yET","productBadge":"ASDFqi"};